'use client';
import ARROWRIGHT from '@/assets/icons/ArrowRight.svg';
import { useTranslation } from '@/i18n/client';
import { useEffect, useState } from 'react';
import style from '../style.module.scss';
// ------------------组件------------------
import JumpLink from '@/components/JumpLink';

// -----------------引入埋点-------------------
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/30451';
// --------------秒杀活动状态--------------
enum ActivityStatus {
  NOT_START = 'not_start',
  ONGOING = 'ongoing',
  ENDED = 'ended',
}
export default function Timer({ pageConfig, moduleData, currentMills }: any) {
  const [countdownStatus, setCountDownStatus] = useState<ActivityStatus>(ActivityStatus.ENDED);
  const [countdown, setCountdown] = useState<string[]>([]);
  const { dataBatch } = moduleData;
  const { t } = useTranslation();

  const refreshCountdown = (endTimestamp: number, now = new Date().getTime()) => {
    const duration = Math.max(~~((endTimestamp - now) / 1000), 0);
    const h = ~~(duration / 60 / 60) + '';
    const m = ~~((duration - ~~h * 60 * 60) / 60) + '';
    const s = (duration % 60) + '';
    setCountdown([h.padStart(2, '0'), m.padStart(2, '0'), s.padStart(2, '0')]);
  };

  useEffect(() => {
    const data = moduleData.externalData?.data?.seckillBatchDtoList[0];
    const endTimestamp = data?.endTime;
    const startTimeStamp = data?.startTime;
    const currentTime = data?.currTime;
    const clientNow = new Date().getTime();
    const diff = currentMills - clientNow; //计算和服务器时间差

    //更新时间和秒杀状态
    const updateCountdown = () => {
      // 如果有活动下发
      if (pageConfig.products && endTimestamp && startTimeStamp && currentTime) {
        // 活动进行中
        if (currentTime >= startTimeStamp && currentTime <= endTimestamp) {
          setCountDownStatus(ActivityStatus.ONGOING);
          refreshCountdown(endTimestamp, new Date().getTime() + diff);
        }
        // 有24小时内即将开始的活动
        else if (
          currentTime < startTimeStamp &&
          startTimeStamp - currentTime <= 24 * 60 * 60 * 1000
        ) {
          setCountDownStatus(ActivityStatus.NOT_START);
        } else {
          setCountDownStatus(ActivityStatus.ENDED);
        }
      } else {
        setCountDownStatus(ActivityStatus.ENDED);
      }
    };

    const timer = setInterval(updateCountdown, 1000);
    updateCountdown();

    return () => clearInterval(timer);
  }, [pageConfig.products, moduleData, currentMills]);

  const flashSales = (text: string, hour: string, minute: string, second: string) => {
    return (
      <JumpLink jumpParams={pageConfig.jumpParams}>
        <div
          className={style.more}
          onClick={() => sendClickTrack.Home_Pro_FlashSales_More()}
          exptag={'exp|' + EXPOSURE_RECORD.Home_Pro_FlashSales_More_Expo}
          data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
        >
          <p>
            <span className={style.timeTitle}>{text}</span>
            <span className={style.timeNum} suppressHydrationWarning>
              {hour}
            </span>
            <span>:</span>
            <span className={style.timeNum} suppressHydrationWarning>
              {minute}
            </span>
            <span>:</span>
            <span className={style.timeNum} suppressHydrationWarning>
              {second}
            </span>
          </p>
          <ARROWRIGHT></ARROWRIGHT>
        </div>
      </JumpLink>
    );
  };

  return (
    <>
      {countdownStatus === ActivityStatus.ONGOING &&
        flashSales(
          `${dataBatch?.Config[0]?.end || t('cms.flashSales.end')}`,
          countdown[0],
          countdown[1],
          countdown[2],
        )}
      {countdownStatus === ActivityStatus.NOT_START &&
        flashSales(
          `${dataBatch?.Config[0]?.start || t('cms.flashSales.start')}`,
          pageConfig.startDate?.getHours().toString().padStart(2, '0') || '00',
          pageConfig.startDate?.getMinutes().toString().padStart(2, '0') || '00',
          pageConfig.startDate?.getSeconds().toString().padStart(2, '0') || '00',
        )}
    </>
  );
}
